<template>
  <v-card class="mt-sm-8 mt-md-5 mt-7 bg-transparent">
    <div>
      <div class="card-padding pb-0">
        <h4 class="text-h4 font-weight-bolder text-typo mb-2">Sign in</h4>
        <p class="mb-0 text-body">Enter your email and password to login</p>
      </div>
      <div class="card-padding pb-4">
        <label v-if="false" class="text-xs text-typo font-weight-bolder ms-1">Name</label>
        <v-text-field
            v-if="false"
            hide-details
            outlined
            background-color="rgba(255,255,255,.9)"
            color="rgba(0,0,0,.6)"
            light
            height="40"
            placeholder="Name"
            class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
        >
        </v-text-field>

        <label class="text-xs text-typo font-weight-bolder ms-1">Email</label>
        <v-text-field
            hide-details
            outlined
            background-color="rgba(255,255,255,.9)"
            color="rgba(0,0,0,.6)"
            light
            height="40"
            placeholder="Email"
            class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
            v-model="email"
        >
        </v-text-field>

        <label class="text-xs text-typo font-weight-bolder ms-1">Password</label>
        <v-text-field
            hide-details
            outlined
            background-color="rgba(255,255,255,.9)"
            color="rgba(0,0,0,.6)"
            light
            height="40"
            type="password"
            placeholder="Password"
            class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-4
          mt-2
        "
            v-model="password"
        >
        </v-text-field>

        <v-checkbox
            v-if="false"
            v-model="checkbox"
            color="#141727"
            :ripple="false"
            class="ma-0 checkbox-custom checkbox-thinner"
            hide-details
        >
          <template v-slot:label>
          <span v-if="false" class="text-typo text-body-2 ls-0"
          >I agree the
            <a
                href="javascript:;"
                class="text-dark font-weight-bolder text-decoration-none"
            >Terms and Conditions</a
            ></span
          >
          </template>
        </v-checkbox>

        <v-btn
            elevation="0"
            :ripple="false"
            height="43"
            class="
          font-weight-bold
          text-uppercase
          btn-primary
          bg-gradient-secondary
          py-2
          px-6
          me-2
          mt-7
          mb-2
          w-100
        "
            color="#5e72e4"
            small
            @click="login()"
        >Sign In</v-btn
        >
        <div class="text-center">
          <p class="text-sm text-body mt-3 mb-0">

            <a
                @click="goToSearch()"
                class="
              text-secondary text-gradient text-decoration-none
              font-weight-bold
            "
            > Check My Organisation ? </a>
          </p>
<!--          <p class="text-sm text-body mt-3 mb-0">-->

<!--            <a-->
<!--                @click="goToRegister()"-->
<!--                class="-->
<!--              text-secondary text-gradient text-decoration-none-->
<!--              font-weight-bold-->
<!--            "-->
<!--            > Register New Organisation ?</a>-->
<!--          </p>-->
          <p class="text-sm text-body mt-3 mb-0">
            <a
                @click="goToRegister()"
                class="
              text-secondary text-gradient text-decoration-none
              font-weight-bold
            "
            > Request a new password </a>
          </p>
        </div>
      </div>
    </div>
    <v-dialog
        v-model="resetEmail"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Reset Password
        </v-card-title>

        <v-card-text>
          <label class="text-xs text-typo font-weight-bolder ms-1">Enter your email below</label>
          <v-text-field
              hide-details
              outlined
              background-color="rgba(255,255,255,.9)"
              color="rgba(0,0,0,.6)"
              light
              height="40"
              placeholder="Email"
              class="
          input-style
          font-size-input
          border border-radius-md
          placeholder-lighter
          text-color-light
          mb-2
          mt-4
        "
              v-model="otpEmail"
          >
          </v-text-field>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="red darken-1"
              text
              outlined
              @click="resetEmail = false"
          >
            Close
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="resetEmail = false"
          >
            SEND OTP
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="successDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Information
        </v-card-title>

        <v-card-text>
          Your application is still pending approval.
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="green darken-1"
              text
              outlined
              @click="successDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="errorDialog"
        max-width="290"
        persistent
    >
      <v-card class="text-center ">
        <v-card-title class="text-h5 justify-center">
          Error
        </v-card-title>

        <v-card-text>
          Invalid credentials
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
              color="danger darken-1"
              text
              outlined
              @click="errorDialog = false"
          >
            Retry
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            size="64"
        />
      </v-overlay>
    </div>
  </v-card>
</template>
<script>
import axios from 'axios'
import {mapState} from "vuex";

export default {
  name: "sign-up-illustration",
  data() {
    return {
      overlay: false,
      resetEmail: false,
      successDialog: false,
      errorDialog: false,
      checkbox: false,
      email:'',
      otpEmail:'',
      password:'',
    };
  },
  computed: {
    ...mapState(['base_url']),
  },
  methods: {
    goToRegister(){
      this.$router.replace("/register");
    },
    goToSearch(){
      this.$router.replace("/search");
    },
    async login () {
      const payload = {
        "email": this.email,
        "password": this.password
      }
      this.overlay = true
      await new Promise((resolve) => setTimeout(resolve, 3000));
      await axios
          .post(this.base_url + "/auth/login/", payload)
          .then((response) => {
            console.log(response)
            if (response.status === 200) {
              console.log(response.data);
              if (response.data.is_verified){
                this.$store.commit("setRefreshToken", response.data.refresh);
                this.$store.commit("setAccessToken", response.data.access);
                this.$store.commit("setAuthenticated", true);
                this.$store.commit("setIsAdmin", response.data.is_staff);
                this.$store.commit("setIsITAdmin", response.data.is_administrator);
                this.$store.commit("setIsFinance", response.data.is_finance);
                this.$store.commit("setIsExecutive", response.data.is_executive);
                this.$store.commit("setIsAgent", response.data.is_agent);
                this.$store.commit("setIsRecords", response.data.is_records);
                this.$store.commit("setIsReception", response.data.is_reception);
                this.$store.commit("setIsApprover", response.data.is_approver);
                if(response.data.is_staff){
                  this.overlay = false;
                  this.$router.replace("/admin-dashboard");
                }
                else{
                  this.overlay = false;
                  this.$router.replace("/client-returns");
                }
              }
              else{
                this.overlay = false;
                this.successDialog = true
              }
            } else {
              this.overlay = false;
              this.errorDialog = true
              console.log(response)
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.overlay = false;
              this.errorDialog = true
            } else if (error.response.status === 400) {
              this.overlay = false;
              this.errorDialog = true
            } else if (error.response.status === 500) {
              this.overlay = false;
              this.errorDialog = true
            }else{
              this.overlay = false;
              this.errorDialog = true
            }
          });
    },
    goTo(){
      if(this.email === 'admin'){
        this.$store.commit("setAuthenticated", true);
        this.$store.commit("setIsAdmin", true);
        this.$router.replace("/admin-dashboard");
      }
      else{
        this.$store.commit("setAuthenticated", true);
        this.$store.commit("setIsAdmin", false);
        this.$router.replace("/client-dashboard");
      }

    },
    async sendOTPEmail(){
      const payload = {
        "email": this.otpEmail,
      }
      this.overlay = true
      this.resetEmail = false
      await new Promise((resolve) => setTimeout(resolve, 3000));
      await axios
          .post(this.base_url + "/auth/login/", payload)
          .then((response) => {
            console.log(response)
            if (response.status === 200) {
              console.log(response.data);
              this.overlay = false
            } else {
              this.overlay = false;
              this.errorDialog = true
              console.log(response)
            }
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.overlay = false;
              this.errorDialog = true
            } else if (error.response.status === 400) {
              this.overlay = false;
              this.errorDialog = true
            } else if (error.response.status === 500) {
              this.overlay = false;
              this.errorDialog = true
            }else{
              this.overlay = false;
              this.errorDialog = true
            }
          });
    }
  },
};
</script>
